<template>
  <v-alert
    v-if="areas.length"
    :type="revealed ? 'error' : 'warning'"
    variant="tonal"
    rounded="lg"
    icon="mdi-format-list-checks"
    class="onboarding-missing-fields"
    data-testid="onboarding-missing-fields"
  >
    <div class="text-body-2 font-weight-bold mb-1">
      {{ $t('onboarding.wizard.data-entry.missing-fields-title') }}
    </div>
    <div class="text-body-2 mb-2">
      {{ $t('onboarding.wizard.data-entry.missing-fields-hint') }}
    </div>
    <div
      v-for="area in areas"
      :key="area.areaLabel"
      class="text-body-2 mb-1"
    >
      <span class="font-weight-medium">{{ area.areaLabel }}:</span>
      <template
        v-for="(field, index) in area.fields"
        :key="field.key"
      >
        <button
          type="button"
          class="onboarding-missing-fields__link"
          @click="goToField(field.key)"
        >
          {{ field.label }}</button
        ><span v-if="index < area.fields.length - 1">,</span>
      </template>
    </div>
  </v-alert>
</template>

<script setup lang="ts">
import type { MissingOnboardingArea } from '../../composables/useOnboardingDataCompleteness'

defineProps<{
  areas: MissingOnboardingArea[]
  /** Continue was attempted with missing data — switch from a warning to an error. */
  revealed: boolean
}>()

function goToField(key: string) {
  const target = document.querySelector(`[data-ai-field="${key}"]`)
  if (!(target instanceof HTMLElement)) return
  target.scrollIntoView({ behavior: 'smooth', block: 'center' })
  const input = target.matches('input, textarea')
    ? target
    : target.querySelector<HTMLElement>('input, textarea, [tabindex="0"]')
  input?.focus({ preventScroll: true })
}
</script>

<style scoped>
.onboarding-missing-fields__link {
  margin-left: 4px;
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}
</style>
